/** Breadcrumb as an eyebrow: uppercase label links in text.muted, current page in text.primary. */
export const Breadcrumb = {
  baseStyle: {
    link: {
      fontFamily: "body",
      fontSize: "0.75rem",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: "text.muted",
      _hover: { color: "text.primary", textDecoration: "none" },
      _focusVisible: { boxShadow: "outline", borderRadius: "sm" },
      "&[aria-current=page]": { color: "text.primary" },
    },
    separator: { color: "sand.400", mx: 2 },
  },
};
